/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-chevron': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M13.68 9.59l-8.16 8.16a.86.86 0 01-.6.25.82.82 0 01-.59-.25.85.85 0 010-1.19L11.88 9 4.33 1.44a.85.85 0 010-1.2.86.86 0 011.19 0l8.16 8.16a.86.86 0 010 1.19z"/>'
  }
})
